import {Component, HostListener, OnInit} from '@angular/core';
import {ParcelsService} from '../../../services/parcels.service';
import {HistoryItem} from '../../directory-item/activity/history-item.class';
import {UrlService} from '../../../services/url.service';

@Component({
    selector: 'parcel-history',
    templateUrl: 'parcel-history.component.html',
    styleUrls: ['parcel-history.component.scss']
})
export class ParcelHistoryComponent implements OnInit {
    parcelNumber: string;
    parcelId: number;
    suiteId: number;
    showModal = false;
    activities: HistoryItem[] = [];

    constructor(
        public parcelsService: ParcelsService,
        public urlService: UrlService
    ) {}

    ngOnInit() {
        this.parcelId      = this.parcelsService.parcelInHistoryModal.id;
        this.parcelNumber  = this.parcelsService.parcelInHistoryModal.parcelNumber;
        this.suiteId       = this.parcelsService.parcelInHistoryModal.suiteId;
        this.getActivityParcels();
        setTimeout( () => this.showModal = true, 300);
        this.urlService.modalOpened.emit();
    }

    getActivityParcels() {
        const url = `/v1/history.json?per-page=10000&order-by=loggedAt|desc&objectId=${this.parcelId}`;
        this.parcelsService.api.get('domainParcels', url).subscribe(
            res   => this.activities = res.json().map(a => new HistoryItem(a)),
            error => this.parcelsService.api.errorHandler(error, 'Failed get Parcels')
        );
    }

    hideModal() {
        this.parcelsService.isParcelHistoryModalShow = false;
        this.parcelsService.parcelInHistoryModal = null;
        this.urlService.modalClosed.emit();
    }

    @HostListener('document:keydown.escape', ['$event']) onKeydownHandler(event: KeyboardEvent) {
        setTimeout(() => this.hideModal(), 100);
    }
}



// WEBPACK FOOTER //
// /app/src/app/views/parcels/parcel-history/parcel-history.component.ts